import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template"]
  static values = { levels: Object, defaultLevel: String, max: { type: Number, default: 4 } }

  show(event) {
    const { message, type, duration } = event.detail || {}
    if (!message) return

    const level = this.levelsValue[type] ? type : this.defaultLevelValue
    const { color, duration: fallback, assertive } = this.levelsValue[level]
    const toast = this.templateTarget.content.firstElementChild.cloneNode(true)
    const requested = Number(duration ?? fallback)
    const ms = Number.isFinite(requested) ? requested : fallback

    toast.dataset.level = level
    toast.dataset.componentToastDurationValue = ms
    toast.style.setProperty("--toast-accent", `var(--color-${color})`)
    toast.setAttribute("role", assertive ? "alert" : "status")
    toast.setAttribute("aria-live", assertive ? "assertive" : "polite")
    this.messageOf(toast).textContent = message

    if (ms <= 0) toast.querySelector("[data-component-toast-target='timer']")?.remove()

    this.dropDuplicate(message, level)
    this.element.appendChild(toast)
    this.dropOverflow()
  }

  // Repeating an identical notification restarts it rather than stacking a copy, matching how
  // the callers that dispatch one toast per API error used to overwrite a single shared element.
  dropDuplicate(message, level) {
    this.toasts.find((t) => t.dataset.level === level && this.messageOf(t).textContent === message)?.remove()
  }

  dropOverflow() {
    this.toasts.slice(0, -this.maxValue).forEach((t) => t.remove())
  }

  messageOf(toast) {
    return toast.querySelector("[data-component-toast-target='message']")
  }

  get toasts() {
    return [...this.element.querySelectorAll(".c-toast")]
  }
}
